import SidebarLink from "@repo/ui/SidebarLink";
import SidebarLinkGroup from "@repo/ui/SidebarLinkGroup";
import {
    Banknote,
    Book,
    BookA,
    BookText,
    Building2,
    LayoutDashboard,
    PcCase,
    SquareChartGantt,
    Store,
    User
} from "lucide-react";
import React from "react";

export const app_version = process.env.NEXT_PUBLIC_APP_VERSION || "dev";
const sidebarItems = [
    {
        id: 1,
        name: "Dashboard",
        path: 'dashboard',
        public: true,
        roles: ["Admin", "User"],
        child: <SidebarLink
            module={'Dashboard'}
            title={<>
                <LayoutDashboard className="size-5"/>
                Dashboard
            </>
            }
            path={'/dashboard'}
        />
    },
    {
        id: 2,
        name: "Cases",
        path: 'cases',
        roles: ["Admin", "User"],
        child:
            <SidebarLink
                module={'Cases'}
                title={<>
                    <BookText className="size-5"/>
                    Cases
                </>
                }
                path={'/cases'}
            />
    },
    {
        id: 12,
        name: "Cases",
        path: 'cases',
        roles: ["Admin", "User"],
        child: <SidebarLink
            module={'Cases'}
            title={<>
                <BookText className="size-5"/>
                New Cases
            </>
            }
            path={'/cases/new'}
        />
    },
    {
        id: 3,
        name: "Manage New Cases",
        path: 'sales',
        roles: ["Admin"],
        child: <SidebarLink
            module={'ManageNewCases'}
            title={<>
                <Building2 className="size-5"/>
                Manage New Cases
            </>} path={'/manage-new-cases'}/>
    },
    {
        id: 20,
        name: "Unresolved Cases",
        path: 'unresolved_cases',
        roles: ["Admin"],
        child: <SidebarLink
            module={'UnresolvedCases'}
            title={<>
                <Building2 className="size-5"/>
                Unresolved cases
            </>} path={'/unresolved_cases'}/>
    },
    {
        id: 4,
        name: "Lost Inbound",
        path: 'lost',
        roles: ["Admin"],
        child: <SidebarLink
            module={'LostInbound'}
            title={<>
                <PcCase className="size-5"/>
                Lost Inbound
            </>} path={'/lost-inbound'}/>
    },
    {
        id: 5,
        name: "Inventory",
        path: 'inventory',
        roles: ["Admin", "User"],
        child: <SidebarLink module={'Inventory'} title={<>
            <SquareChartGantt className="size-5" />
            Inventory
        </>} path={'inventory'}/>
    },
    {
        id: 6,
        name: "Orders",
        path: 'lost',
        roles: ["Admin", "User"],
        child: <SidebarLink module={'Orders'} title={<>
            <BookA className="size-5" />
            Orders
        </>} path={'orders'}/>
    },
    {

        id: 7,
        name: "Users",
        roles: ["Admin"],
        child: <SidebarLink
            module={'Users'}
            title={<>
                <User className="size-5"/>
                Users
            </>} path={'/users'}/>
    },
    {

        id: 8,
        name: "Reimbursements",
        roles: ["Admin"],
        child: <SidebarLink
            module={'Reimbursements'}
            title={<>
                <Banknote className="size-5"/>
                Reimbursements
            </>} path={'/reimbursements'}/>
    },
    {

        id: 9,
        name: "Stores",
        roles: ["Admin", "User"],
        child: <SidebarLink module={'Stores'}
                            title={<>
                                <Store className="size-5"/>
                                Stores
                            </>} path={'/stores'}/>
    },
    {

        id: 10,
        name: "Invoices",
        roles: ["Admin", "User"],
        child: <SidebarLink
            module={'Invoices'}
            title={<>
                <Book className="size-5"/>
                Invoices
            </>} path={'/invoices'}/>
    },
    {

        id: 11,
        name: "Invoices Dashboard",
        roles: ["Admin"],
        child: <SidebarLink
            module={'Invoices Dashboard'}
            title={<>
                <Book className="size-5"/>
                Invoices Dashboard
            </>} path={'/invoices_dashboard'}/>
    },
]
export default sidebarItems